import { ReactElement, useMemo } from 'react';
import whatsapp from '../../assets/whatsapp.png';
import { WhatsAppLinkButtonProps } from './whatsapp-link-button-props';
import * as S from './whatsapp-link-button-styles';

export function WhatsAppLinkButton ({ phone }: WhatsAppLinkButtonProps): ReactElement {
  const clearPhone = useMemo(() => {
    const numbers = phone.replace(/\D/g, '')
    return numbers
  }, [phone])
  if (!clearPhone) return <></>
  return <S.LinkButton href={`https://wa.me/${clearPhone}`} rel="noopener noreferrer" target="_blank">
    <img src={whatsapp} alt="" />
  </S.LinkButton>
}
